import { intercom } from '@/lib/analytics';
import locale from '@/lib/utils/locale';
import getBrandConfig from '@/lib/utils/get_brand_config';

export function intercomPlugin(intercom, locale, getBrandConfig) {
  function update() {
    const intercomUpdate = {
      hide_default_launcher: false,
    };
    if (getBrandConfig().brand === 'ppi') {
      const language = locale.getLanguage();
      if (language === 'fr-CA') {
        intercomUpdate.preferred_language = 'French';
        intercomUpdate.language_override = 'fr';
      } else {
        intercomUpdate.preferred_language = 'English';
        intercomUpdate.language_override = 'en';
      }
    }
    intercom('update', intercomUpdate);
  }

  function install(router) {
    router.afterEach(update);
  }

  return { install, update };
}

export default intercomPlugin(intercom, locale, getBrandConfig).install;
